import React, { useEffect, useState } from 'react';


const Filters = ( {onFilterChange} ) => {

    const [selectedProduct, setSelectedProduct] = useState([]);
    const [selectedPipeline, setSelectedPipeline] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [selectedSource, setSelectedSource] = useState([]);
    const [selectedLevel, setSelectedLevel] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState([]);

    const productsOptions = [
        { id: 1, label: 'Remittance' },
        { id: 2, label: 'Insurance' },
        { id: 3, label: 'Re-KYC' },
        { id: 4, label: 'Referral' },
        { id: 5, label: 'Financing' },
    ];
    const pipelineStage = [
        { id: 1, label: 'Raw' },
        { id: 2, label: 'Fresh' },
        { id: 3, label: 'Profile Completed' },
        { id: 4, label: 'Information Gathered' },
        { id: 5, label: 'Onboarded' },
        { id: 6, label: 'Activated' }
    ];
    const leadStatus = [
        { id: 0, label: 'Active' },
        { id: 1, label: 'Ongoing' },
        { id: 2, label: 'Inactive' },
        { id: 3, label: 'Tanked' }
    ];
    const leadSource = [
        { id: 1, label:"Self-Generated" },
        { id: 2, label:"Referral (Hunter)" },
        { id: 3, label:"Referral (MM Employee)" },
        { id: 4, label:"Referral (Public)" },
        { id: 5, label:"Inbound" },
        { id: 6, label:"Boost" },
        { id: 7, label:"Referral (Farmer)" },
        { id: 8, label:"Webscraping" },
        { id: 9, label:"Lazada" },
        { id: 10, label:"Bytedance" },
        { id: 11, label:"Referral Scheme" }
    ];
    const interestLevel = [
        { id: 1, label: 'Cold' },
        { id: 2, label: 'Warm' },
        { id: 3, label: 'Hot' }
    ];
      const region = [
        { id: 1, label: 'MY' },
        { id: 2, label: 'SG' },
        { id: 3, label: 'BN' },
        { id: 4, label: 'AU' }
    ];



    const handleToggleProduct = (optionId) => {
        setSelectedProduct(prev => 
        prev.includes(optionId)
            ? prev.filter(id => id !== optionId)
            : [...prev, optionId]
        );
    };

    const handleTogglePipeline = (optionId) => {
        setSelectedPipeline(prev => 
        prev.includes(optionId)
            ? prev.filter(id => id !== optionId)
            : [...prev, optionId]
        );
    };
    const handleToggleStatus = (optionId) => {
        setSelectedStatus(prev =>
        prev.includes(optionId)
            ? prev.filter(id => id !== optionId)
            : [...prev, optionId]
        );
    };
    const handleToggleSource = (optionId) => {
        setSelectedSource(prev =>
        prev.includes(optionId)
            ? prev.filter(id => id !== optionId)
            : [...prev, optionId]
        );
    };
    const handleToggleLevel = (optionId) => {
        setSelectedLevel(prev =>
        prev.includes(optionId)
            ? prev.filter(id => id !== optionId)
            : [...prev, optionId]
        );
    };
    const handleToggleRegion = (optionId) => {
        setSelectedRegion(prev =>
        prev.includes(optionId)
            ? prev.filter(id => id !== optionId)
            : [...prev, optionId]
        );
    }
    const Dropdown = ({ 
        label, 
        selected, 
        options, 
        handleToggle, 
        onClear 
      }) => (
        <div className="relative group">
          <button
            className="px-4 py-2 bg-transparent hover:bg-yellow-100 rounded-lg
                       flex items-center space-x-2 font-medium text-gray-700
                       transition-colors duration-200"
          >
            <span>{label}</span>
            {selected.length > 0 && (
              <span className="ml-2 inline-flex items-center justify-center px-2 py-0.5 
                              bg-yellow-100 text-yellow-700 text-xs font-medium rounded-full">
                {selected.length}
              </span>
            )}
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={`w-4 h-4 transition-transform duration-200 ${
                'group-hover:rotate-180'
            }`}>
                <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
            </svg>
          </button>
    
          <div className="absolute left-0 mt-2 w-48 bg-white/80 backdrop-blur-sm border border-gray-200 
                          rounded-lg shadow-lg py-2 z-50 invisible group-hover:visible
                          transition-all duration-200 opacity-0 group-hover:opacity-100">
            {options.map((option) => (
              <label
                key={option.id}
                className="flex items-center px-4 py-2 hover:bg-yellow-100 cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={selected.includes(option.id)}
                  onChange={() => handleToggle(option.id)}
                  className="h-4 w-4 rounded border-gray-300 text-yellow-500 
                             focus:ring-yellow-500 cursor-pointer"
                />
                <span className="ml-3 text-gray-700">{option.label}</span>
              </label>
            ))}
            
            {selected.length > 0 && (
              <div className="border-t border-gray-200 mt-2 pt-2 px-4">
                <button
                  onClick={onClear}
                  className="text-sm text-yellow-600 hover:text-yellow-700"
                >
                  Clear all
                </button>
              </div>
            )}
          </div>
        </div>
    );

    useEffect(() => {
        const selectedFilters = {
            products: selectedProduct,
            pipelineStage: selectedPipeline,
            leadStatus: selectedStatus,
            leadSource: selectedSource,
            interestLevel: selectedLevel,
            region: selectedRegion
        };

        onFilterChange(selectedFilters);
    }, [selectedProduct, selectedPipeline, selectedStatus, selectedSource, selectedLevel, selectedRegion]);

    return(
        <div>
            <h1 className="font-bold pb-4">Quick Filter</h1>
            <div className="flex flex-row justify-between items-center">
                <p className="font-bold text-gray-500">Filter by:</p>
                <Dropdown 
                    label="Product"
                    selected={selectedProduct}
                    options={productsOptions}
                    handleToggle={handleToggleProduct}
                    onClear={() => setSelectedProduct([])}
                />
                <Dropdown 
                    label="Pipeline Stage"
                    selected={selectedPipeline}
                    options={pipelineStage}
                    handleToggle={handleTogglePipeline}
                    onClear={() => setSelectedPipeline([])}
                />
                <Dropdown
                    label="Lead Status"
                    selected={selectedStatus}
                    options={leadStatus}
                    handleToggle={handleToggleStatus}
                    onClear={() => setSelectedStatus([])}
                />
                <Dropdown
                    label="Source"
                    selected={selectedSource}
                    options={leadSource}
                    handleToggle={handleToggleSource}
                    onClear={() => setSelectedSource([])}
                />
                <Dropdown
                    label="Interest Level"
                    selected={selectedLevel}
                    options={interestLevel}
                    handleToggle={handleToggleLevel}
                    onClear={() => setSelectedLevel([])}
                />
                <Dropdown
                    label="Region"
                    selected={selectedRegion}
                    options={region}
                    handleToggle={handleToggleRegion}
                    onClear={() => setSelectedRegion([])}
                />
                 <button 
                 onClick={() => {
                    setSelectedProduct([]);
                    setSelectedPipeline([]);
                    setSelectedStatus([]);
                    setSelectedSource([]);
                    setSelectedLevel([]);
                    setSelectedRegion([]);
                }}
                 className="px-4 py-2 bg-transparent hover:bg-yellow-100 rounded-lg
                            flex items-center space-x-2 font-bold text-gray-700
                            underline transition-colors duration-200"
                 >Clear Filters
                 </button>
            </div>
        </div>
    )
}

export default Filters;
